import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';
import type { SettingsResponse } from '@/types/api';

// Whitelist-Keys werden vom Backend in READABLE_KEYS gepflegt; hier ist
// der Query-Parameter Komma-getrennt, der Query-Key enthaelt sie sortiert
// damit verschiedene Key-Kombinationen eigene Cache-Eintraege haben.
export function useSettings(keys: readonly string[]) {
  const sorted = [...keys].sort();
  return useQuery({
    queryKey: ['settings', ...sorted],
    queryFn: () =>
      apiFetch<SettingsResponse>(`/settings.php?keys=${encodeURIComponent(sorted.join(','))}`),
    staleTime: 5 * 60_000
  });
}
